import React from 'react';
import './index.css';
import ImageComponent from './ImageComponent';
import { deleteItem } from '../../api/client';
import { getLoggedUserUID, isLoggedIn } from '../../api/userManagement';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import { IconButton } from '@material-ui/core';

import * as moment from 'moment';
import * as ELG from 'esri-leaflet-geocoder';

class PostcardItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: '',
      date: ''
    };
  }
  componentDidMount() {
    let date =
      this.props.date && this.props.date.toDate
        ? this.props.date.toDate()
        : new Date();
    this.setState({ date: date });
    const LatLng = {
      lat: this.props.location.latitude,
      lng: this.props.location.longitude
    };
    ELG.reverseGeocode()
      .latlng(LatLng)
      .run((err, results) => {
        // const { address } = results;
        const location = err
          ? 'Somewhere'
          : results && results.address.CountryCode
          ? (results.address.City
              ? results.address.City + ', '
              : results.address.Region
              ? results.address.Region + ', '
              : '') + results.address.CountryCode
          : results.address.PlaceName;
        this.setState({ location: location });
      });
  }

  handleDelete = () => {
    deleteItem(this.props.id);
    this.setState(null);
    this.props.handleDelete(this.props.id);
  };

  render() {
    let btn = null;
    if (isLoggedIn()) {
      if (this.props.author === getLoggedUserUID())
        btn = (
          <IconButton aria-label="Delete" onClick={() => this.handleDelete()}>
            {' '}
            <DeleteIcon />{' '}
          </IconButton>
        );
    }

    return (
      <Card className={this.props.className}>
        <div className="postcard-item-content">
          <CardHeader
            avatar={
              <Avatar aria-label="Recipe">
                {this.props.author ? this.props.author.toUpperCase()[0] : 'S'}
              </Avatar>
            }
            title={this.props.title}
            subheader={`Posted by ${
              this.props.author ? this.props.author : 'Someone'
            }`}
          />
          <CardContent>
            <Typography component="p">{this.props.description}</Typography>
          </CardContent>

          <CardHeader
            subheader={` ${this.state.location} on ${moment(this.state.date)
              .format('Do MMM YYYY')
              .toString()}`}
          />
        </div>

        <div className="postcard-item-image">
          <ImageComponent
            fileName={this.props.image}
            title={this.props.title}
          />
        </div>
        {btn}
      </Card>
    );
  }
}

export default PostcardItem;
